/* Stix PDP "No Tour Tax" Proof Element — CRO Test Router
 * --------------------------------------------------------
 * Test ID: cl-pdp-no-tour-tax-proof
 * Arms:    control / A inline / C compare-table / D inline-crossout (B removed 2026-05-13)
 *
 * Pattern mirrors stix-picker-test-router.js.
 * Variants pre-rendered server-side; this script picks an arm + reveals it.
 * URL override: ?cl_proof_v=control|A|C|D — for QA / preview.
 * TEST_MODE='live' = real traffic split (active). 'smoke' = preview-only.
 */
(function () {
  'use strict';

  var TEST_ID = 'pdp_no_tour_tax_proof';
  var COOKIE_NAME = 'cl_proof_v2';
  var COOKIE_TTL_DAYS = 30;
  var URL_OVERRIDE_PARAM = 'cl_proof_v';
  var SPLIT = [
    { arm: 'control', weight: 30 },  // 2026-05-26 rev2 — narrowed to c
    { arm: 'c',       weight: 70 },  // sig winner +49.3%, p=0.001
  ];
  var VALID_ARMS = { control: 1, c: 1 }; // 2026-05-26 rev2 — kill a, d
  var TEST_MODE = 'live'; // 'smoke' = preview only; 'live' = real traffic split
  // ─── Metafield override (rev2.5 — Wiki/Ecomm/Reports/cro-weekly-2026-05-26 §arch) ───
  // Read shop.metafields.cro.test_config['pdp_no_tour_tax_proof'] from the page-global
  // emitted by snippets/cro-config-global.liquid. If present, REPLACE the
  // hardcoded SPLIT + VALID below so weight changes via Scripts/cro_config.py
  // take effect on next page load without a theme deploy.
  // Falls back to the hardcoded defaults if the global is missing (dev/preview).
  try {
    var __mf = window.STIX_CRO_CONFIG && window.STIX_CRO_CONFIG[TEST_ID];
    if (__mf && __mf.variants && __mf.variants.length) {
      SPLIT = __mf.variants.map(function(v){ return {arm: v.label, weight: v.weight}; });
      VALID_ARMS = {};
      __mf.variants.forEach(function(v){ VALID_ARMS[v.label] = 1; });
      if (__mf.status === 'paused' || __mf.status === 'reverted') TEST_MODE = 'smoke';
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'metafield';
    } else {
      window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
      window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback';
    }
  } catch (e) {
    window.STIX_TEST_SOURCE = window.STIX_TEST_SOURCE || {};
    window.STIX_TEST_SOURCE[TEST_ID] = 'hardcoded-fallback-error';
  }


  function getCookie(name) {
    var rx = new RegExp('(?:^|;\\s*)' + name + '=([^;]*)');
    var m = document.cookie.match(rx);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, val, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 86400000));
    document.cookie = name + '=' + encodeURIComponent(val) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function urlOverride() {
    try {
      var p = new URLSearchParams(window.location.search).get(URL_OVERRIDE_PARAM);
      if (!p) return null; p = p.toLowerCase(); return VALID_ARMS[p] ? p : null;
    } catch (e) { return null; }
  }
  function assignArm() {
    var r = Math.random() * 100, cum = 0;
    for (var i = 0; i < SPLIT.length; i++) {
      cum += SPLIT[i].weight;
      if (r < cum) return SPLIT[i].arm;
    }
    return SPLIT[0].arm;
  }
  function isBot() {
    return /bot|crawl|spider|slurp|duckduckbot|baiduspider|yandex|bingpreview|facebookexternalhit|embedly|lighthouse|headlesschrome/i.test(navigator.userAgent || '');
  }

  function init() {
    var root = document.querySelector('[data-cl-proof-router]');
    if (!root) return;

    var arm = urlOverride();
    var fromUrl = !!arm;

    if (!arm) {
      if (TEST_MODE === 'smoke') arm = 'control';
      else if (isBot()) arm = 'control';
      else {
        arm = getCookie(COOKIE_NAME);
        if (!arm || !VALID_ARMS[arm]) {
          arm = assignArm();
          setCookie(COOKIE_NAME, arm, COOKIE_TTL_DAYS);
        }
      }
    } else {
      setCookie(COOKIE_NAME, arm, COOKIE_TTL_DAYS);
    }

    // Light-background detection (2026-06-12, Zach): the Nicklaus C02 PDP
    // renders on a white background, where the dark-bg light-text palette
    // below is illegible. Walk up to the first opaque ancestor, compute its
    // luminance, and flag the root so the CSS can flip to dark text.
    try {
      var bgEl = root, bg = '', m;
      while (bgEl && bgEl !== document.documentElement) {
        bg = getComputedStyle(bgEl).backgroundColor || '';
        m = bg.match(/rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\)/);
        if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) break;
        m = null; bgEl = bgEl.parentElement;
      }
      // 2026-10-09: no opaque ancestor means the page shows the browser's
      // default WHITE canvas. The old fallback read body's transparent
      // rgba(0,0,0,0) as black, so the flip never fired on Nicklaus C02.
      if (!m) { m = [null, 255, 255, 255]; }
      if (m) {
        var lum = (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
        if (lum > 0.6) root.classList.add('cl-proof--on-light');
      }
    } catch (e) {}

    root.setAttribute('data-cl-active-arm', arm);
    var arms = root.querySelectorAll('[data-cl-arm]');
    for (var i = 0; i < arms.length; i++) {
      if (arms[i].getAttribute('data-cl-arm') === arm) {
        arms[i].hidden = false;
        arms[i].removeAttribute('hidden');
      } else {
        arms[i].hidden = true;
      }
    }

    window.STIX_TEST = window.STIX_TEST || {};
    window.STIX_TEST[TEST_ID] = arm;
    if (typeof window.stixCroExpose === "function") { window.stixCroExpose(TEST_ID, arm, { page_type: "pdp" }); }

    // Arm D = inline crossout in the price row, replacing "from $X/mo".
    // Only run for D (and clean up if user toggled away).
    if (arm === 'd') applyArmD(root);

    var trackOverride = (new URLSearchParams(window.location.search).get('cl_proof_track') === '1');
    if (TEST_MODE === 'live' || (fromUrl && trackOverride)) fireExposure(arm);

    wireModal(root);
  }

  function applyArmD(root) {
    // Get a la carte total from the D node's data attribute.
    var dNode = root.querySelector('[data-cl-arm="d"]');
    if (!dNode) return;
    var alacarte = dNode.getAttribute('data-cl-d-alacarte') || '';
    if (!alacarte) return;

    function attempt() {
      // Find the "from $X/mo" sibling of the price-container. The theme renders:
      //   <span class="text-base text-darkgray shrink-0 font-jost">&nbsp;from $X/mo</span>
      // sitting inside the same .prices flex row as [data-product-price]. It's
      // the only sibling with text "from" + "/mo".
      var candidates = document.querySelectorAll('.prices > span, [data-price-container] > span');
      var target = null;
      for (var i = 0; i < candidates.length; i++) {
        var t = (candidates[i].textContent || '').trim();
        if (/^from\s+\$.+\/mo$/i.test(t)) { target = candidates[i]; break; }
      }
      if (!target) return false;

      // Build the replacement node and swap it in. Keep the existing element
      // intact in the DOM (hidden) so it can be restored if the user changes
      // arms via URL override.
      target.style.display = 'none';
      target.setAttribute('data-cl-d-original','1');

      var span = document.createElement('span');
      span.className = 'cl-proof-d-inline';
      span.setAttribute('data-cl-d-replacement','1');
      // Order: strike-out price → "the other guys" label → "View details" trigger.
      span.innerHTML =
        '<span class="cl-proof-d-inline__strike">' + alacarte + '</span>' +
        '<span class="cl-proof-d-inline__label">the other guys</span>' +
        '<span class="cl-proof-d-inline__sep">·</span>' +
        '<button type="button" class="cl-proof-d-inline__trigger" data-cl-proof-modal-trigger>View details</button>';
      target.parentNode.insertBefore(span, target.nextSibling);
      return true;
    }
    if (attempt()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (attempt() || tries > 40) clearInterval(iv);
    }, 120);
  }

    function fireExposure(arm){
      // Delegates to the shared helper which handles:
      //   - cro_test_<id>=<arm> cart attribute
      //   - dataLayer.push (unconditional)
      //   - gtag('event','ab_test_exposure') with 5s retry
      //   - stix.track.exposeTest (Klaviyo + TW)
      // Helper is idempotent per (testId, arm), so safe to invoke twice
      // (once right after assignment, once from the legacy call site).
      if (typeof window.stixCroExpose === 'function') {
        window.stixCroExpose(TEST_ID, arm, { page_type: 'pdp' });
        return;
      }
      // Inline fallback if stix-cro-expose.js failed to load.
      try {
        (window.dataLayer = window.dataLayer || []).push({
          event: 'ab_test_exposure', cl_test_id: TEST_ID, cl_test_variant: arm,
          page_type: 'pdp', page_path: location.pathname
        });
      } catch (e) {}
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'attributes[cro_test_' + TEST_ID + ']=' + encodeURIComponent(arm),
          credentials: 'same-origin', keepalive: true
        }).catch(function(){});
      } catch (e) {}
    }
  function wireModal(root) {
    var modal = document.getElementById('cl-no-tour-tax-modal');
    if (!modal) return;
    var closeBtn = modal.querySelector('[data-cl-proof-modal-close]');
    var backdrop = modal.querySelector('[data-cl-proof-modal-backdrop]');

    function open() {
      modal.hidden = false;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (typeof gtag === 'function') {
        gtag('event', 'cl_proof_modal_open', {
          cl_test_id: TEST_ID,
          cl_test_variant: root.getAttribute('data-cl-active-arm') || 'unknown'
        });
      }
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    // Global delegated click listener — works for triggers inside the proof
    // root AND for arm D's trigger that gets injected into the price row
    // (outside the root) by applyArmD.
    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== document) {
        if (t.matches && t.matches('[data-cl-proof-modal-trigger]')) {
          e.preventDefault();
          open();
          return;
        }
        t = t.parentNode;
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
